import { useEffect, useRef } from 'react';

export default function useConversationScroll({ messages, assistant, containerRef, endRef, busy, requestFollowRef }) {
  const follow = useRef(true);
  const previous = useRef({ lastId: null, structuredId: null, messages: null });
  const onScroll = () => {
    const container = containerRef.current;
    if (container) follow.current = container.scrollHeight - container.scrollTop - container.clientHeight < 96;
  };

  useEffect(() => {
    const last = messages[messages.length - 1];
    const prior = previous.current;
    const structured = last?.type === 'assistant' && !last.isGenerating
      && (last.discovery || last.builderFlow);
    const newUserMessage = last?.type === 'user' && prior.lastId !== last.id;
    const completedStructuredMessage = structured && prior.structuredId !== last.id;
    previous.current = {
      lastId: last?.id,
      structuredId: structured ? last.id : prior.structuredId,
      messages,
    };
    if (!assistant) {
      endRef.current?.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (newUserMessage || requestFollowRef?.current) follow.current = true;
    if (requestFollowRef) requestFollowRef.current = false;
    if (!follow.current) return;
    const container = containerRef.current;
    if (completedStructuredMessage && container) {
      // Anchor a long result at its beginning, rather than skipping to its footer.
      const element = Array.from(container.querySelectorAll('[data-assistant-message]'))
        .find((node) => node.dataset.assistantMessage === String(last.id));
      if (element) {
        container.scrollTop += element.getBoundingClientRect().top - container.getBoundingClientRect().top - 16;
        follow.current = false;
        return;
      }
    }
    if (prior.messages !== messages) endRef.current?.scrollIntoView({ behavior: 'auto', block: 'nearest' });
  }, [messages, assistant, containerRef, endRef, busy, requestFollowRef]);

  return onScroll;
}
